import React from 'react';
import moment from 'moment';
import { CircularProgress } from '@material-ui/core';
import { FiZapOff } from 'react-icons/fi';
import { Typography } from 'material-ui';
import { Doughnut, Chart } from 'react-chartjs-2';
import 'chartjs-plugin-piechart-outlabels';
import * as Decimal from 'decimal.js';

export class HourlyDoughnutCardContent extends React.Component {
  componentWillMount = () => {
    Chart.pluginService.register({
      beforeDraw: function(chart) {
        if (chart.config.options.elements.center) {
          //Get ctx from string
          var ctx = chart.chart.ctx;
          //Get options from the center object in options
          var centerConfig = chart.config.options.elements.center;
          var fontStyle =
            centerConfig.fontStyle ||
            '"Inter-Regular", "Avenir", "Helvetica", "Arial", sans-serif';
          var txt = centerConfig.text;
          var color = centerConfig.color || '#000';
          var sidePadding = centerConfig.sidePadding || 20;
          var sidePaddingCalculated =
            (sidePadding / 100) * (chart.innerRadius * 2);
          //Start with a base font of 30px
          ctx.font = '20px ' + fontStyle;

          //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
          var stringWidth = ctx.measureText(txt).width;
          var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

          // Find out how much the font can grow in width.
          var widthRatio = elementWidth / stringWidth;
          var newFontSize = Math.floor(20 * widthRatio);
          var elementHeight = chart.innerRadius * 2;

          // Pick a new font size so it will not be larger than the height of label.
          var fontSizeToUse = Math.min(newFontSize, elementHeight);

          //Set font settings to draw it correctly.
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
          var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
          ctx.font = fontSizeToUse + 'px ' + fontStyle;
          ctx.fillStyle = color;

          //Draw text in center
          ctx.fillText(txt, centerX, centerY);
        }
      },
    });
  };

  render() {
    const { classes, chartName, t, i18n, loading, barChartData } = this.props;

    if (loading) {
      return <CircularProgress size={24} className={classes.buttonProgress} />;
    }

    if (
      !barChartData ||
      (barChartData && !barChartData.labels) ||
      (barChartData && !barChartData.data) ||
      (barChartData &&
        barChartData.labels &&
        barChartData.labels.length === 0) ||
      (barChartData && barChartData.data && barChartData.data.length === 0)
    ) {
      return (
        <Typography variant="body2" style={{ margin: 10, color: '#CECECE' }}>
          <FiZapOff style={{ position: 'relative', top: 3, marginRight: 10 }} />
          {t('No data yet')}
        </Typography>
      );
    }

    let dateFormat = 'YYYY-MM-DD'; //English date
    if (i18n.language === 'fr') {
      dateFormat = 'DD-MM-YYYY';
    } else if (i18n.language === 'en_us') {
      dateFormat = 'MM-DD-YYYY'; //American date
    }

    let hourFormat = 'HH:mm'; //English date'
    if (i18n.language === 'en_us') {
      hourFormat = 'h a'; //American date
    }

    // A- the hours of the day will be represented as labels
    let hoursArray = new Array(24).fill(0).map((_, i) =>
      moment()
        .startOf('day')
        .add(i, 'hours')
        .format(hourFormat)
    );

    // B- display one label out of 2 to avoid cluttering the graph
    let labelsVisibility = hoursArray.map((hour, i) =>
      i % 2 === 0 ? true : false
    );

    // C- convert the data and make the necessary calculations to display an average hourly matching rate
    let matchedEnergyRatioForEachDayPerHourArray = [[]];
    // C.1 - calculate the hourly matching rate (totalConsumption / matchedConsumption) for each day => matchedEnergyRatioForEachDayPerHourArray
    let firstDate = barChartData.labels[0];
    matchedEnergyRatioForEachDayPerHourArray[
      moment(firstDate).format(dateFormat)
    ] = [];
    for (let i = 0; i < barChartData.labels.length; i++) {
      if (moment(barChartData.labels[i]).diff(firstDate, 'days') >= 1) {
        firstDate = barChartData.labels[i];
        matchedEnergyRatioForEachDayPerHourArray[
          moment(firstDate).format(dateFormat)
        ] = [];
      }
      let totalConsumptionForDayAndHour =
        barChartData.data[barChartData.data.length - 1].data[i];
      let matchedConsumptionForDayAndHour = 0;
      for (let j = 0; j < barChartData.data.length - 1; j++) {
        matchedConsumptionForDayAndHour += barChartData.data[j].data[i];
      }
      matchedEnergyRatioForEachDayPerHourArray[
        moment(firstDate).format(dateFormat)
      ].push({
        hour: moment(barChartData.labels[i]).format(hourFormat),
        matchingRatio:
          matchedConsumptionForDayAndHour / totalConsumptionForDayAndHour,
      });
    }
    // C.2- calculate the average hourly matching rate over all days => averageMatchedEnergyRatioPerHourArray
    let averageMatchedEnergyRatioPerHourArray = [];
    hoursArray.map(hour => {
      let matchedEnergyRatioForHour = 0;
      let nbOfDays = 0;
      Object.keys(matchedEnergyRatioForEachDayPerHourArray).forEach(function(
        dayKey,
        index
      ) {
        let matchedEnergyRatioForDayPerHour =
          matchedEnergyRatioForEachDayPerHourArray[dayKey];
        let matchedEnergyRatioForDayForThisSpecificHour = matchedEnergyRatioForDayPerHour.find(
          e => e.hour === hour
        );
        if (
          matchedEnergyRatioForDayForThisSpecificHour &&
          matchedEnergyRatioForDayForThisSpecificHour.matchingRatio
        ) {
          nbOfDays++;
        }
        matchedEnergyRatioForHour +=
          matchedEnergyRatioForDayForThisSpecificHour &&
          matchedEnergyRatioForDayForThisSpecificHour.matchingRatio
            ? matchedEnergyRatioForDayForThisSpecificHour.matchingRatio
            : 0;
      });
      averageMatchedEnergyRatioPerHourArray[hour] =
        matchedEnergyRatioForHour / nbOfDays;
    });
    // C.3- flatten the resulting array in order to get a unidimensional array
    let averageMatchedEnergyRatioPerHourFlatArray = [];
    Object.keys(averageMatchedEnergyRatioPerHourArray).forEach(function(
      key,
      index
    ) {
      averageMatchedEnergyRatioPerHourFlatArray.push(
        new Decimal.Decimal(
          averageMatchedEnergyRatioPerHourArray[key] * 100
        ).toFixed(2)
      );
    });

    // D- set up colors corresponding to each data item of the doughnut
    let dataArray = averageMatchedEnergyRatioPerHourFlatArray;
    let colorsArray = dataArray.map(
      value => `rgba(53, 179, 255, ${1 - (100 - value) / 100})`
    );

    // E- supply the data to be displayed in the doughnut
    // Notice that we are providing an fake array of 24 items with a single value (100%) everywhere, in order to make the donut segments evenly distributed.
    // You will notice that below, in return() section, we change the labels to display their original values, though.
    // The visualization of the colors for each segment is based on the order of the elements in the original array (dataArray) as shown above.
    const fakeDataArray = new Array(24).fill(100);
    const data = {
      labels: hoursArray,
      datasets: [
        {
          data: fakeDataArray,
          backgroundColor: colorsArray,
        },
      ],
    };

    // F- display data
    return (
      <Doughnut
        key={`${chartName}-chart`}
        ref={ref => {
          this.myDoughnutChart = ref;
        }}
        data={data}
        width={1200}
        height={400}
        options={{
          cutoutPercentage: 70,
          layout: {
            padding: {
              left: 50,
              right: 50,
              top: 80,
              bottom: 50,
            },
          },
          plugins: {
            outlabels: {
              text: '%l',
              display: labelsVisibility,
              color: 'white',
              stretch: 45,
              font: {
                resizable: true,
                minSize: 12,
                maxSize: 18,
              },
            },
          },
          legend: {
            display: false,
          },
          maintainAspectRatio: false,
          responsive: true,
          tooltips: {
            callbacks: {
              title: function(tooltipItem, data) {
                return data['labels'][tooltipItem[0]['index']];
              },
              label: function(tooltipItem) {
                // <--- here we take back the original values by copying those of dataArray instead of using data array (which corresponds to fakeDatArray)
                let chartData = dataArray;

                let rawPercentage = new Decimal.Decimal(
                  chartData[tooltipItem.index]
                );

                let dataDisplayed = rawPercentage.toFixed(2) + '%';

                return dataDisplayed;
              },
            },
          },
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartCards/HourlyDoughnutCardContent.js